import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import {
  Checkbox,
  DatePicker,
  Flex,
  Select,
  Typography,
} from "antd";
import { getClubs, getMonths } from "src/store/Slices/DropDownSlice";
export const DefaultModalComponent = ({
  commentModal,
  fromDate,
  clubId,
  months,
  oneDay,
  extension,
  setCommentModal,
  setFromDate,
  setClubId,
  setMonths,
  setOneDay,
  setExtension,
  clubs,
  monthsCount,
  onClickGetReport,
}) => {
  const dispatch = useDispatch();
  return (
    <CModal
      alignment="center"
      visible={commentModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setCommentModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">{"Отчёт"}</CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Окончившиеся с</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setFromDate(date);
                }}
                value={fromDate}
              />
            </div>
            <div>
              <Typography.Title level={5}>Клуб</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  dispatch(getClubs());
                }}
                value={clubId}
                onChange={(e) => {
                  setClubId(e);
                }}
                options={clubs?.data?.value}
              />
            </div>
            <div>
              <Typography.Title level={5}>Количество месяцев</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  dispatch(getMonths());
                }}
                value={months}
                onChange={(e) => {
                  setMonths(e);
                }}
                options={monthsCount?.data?.value}
              />
            </div>
            <div>
              <Checkbox
                value={oneDay}
                onChange={() => {
                  setOneDay((prev) => !prev);
                }}
                defaultChecked
              >
                С однодневными абонементами
              </Checkbox>
              <Checkbox
                value={extension}
                onChange={() => {
                  setExtension((prev) => !prev);
                }}
                defaultChecked
              >
                С продлёнными абонементами
              </Checkbox>
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setCommentModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickGetReport} style={{ color: "#fff" }}>
          Получить отчёт
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
